module.exports = __webpack_public_path__ + "static/img/lizi2.a81ab87a.png";